import { Injectable } from '@angular/core';
import {
    IEquity,
    IFinancialLineItemComponent,
    IFreeTable,
    IMovementScheduleComponent,
    INotesSelectComponent,
} from '@modeso/types__aumico-lib-annualreport-be';
import { IAnnualReportDefaultSettings } from '../interfaces/IAnnualReportDefaultSettings.interface';

@Injectable({ providedIn: 'root' })
export class ComponentDataSettingsUpdaterHelper {
    public updateCurrencyAndDatesOfEquityAndFreeTable(
        data: IEquity | IFreeTable,
        settings: IAnnualReportDefaultSettings,
    ): IEquity | IFreeTable {
        data.currency = settings.currency;
        data.currentDate = settings.currentBalanceDate;
        data.previousDate = settings.previousBalanceDate;
        return data;
    }

    public updateCurrencyAndDatesOfFinancialLineItem(
        data: IFinancialLineItemComponent,
        settings: IAnnualReportDefaultSettings,
    ): IFinancialLineItemComponent {
        data.currentBalanceYearDate = settings.currentBalanceDate;
        data.previousBalanceYearDate = settings.previousBalanceDate;
        data.currentIncomeYearDate = settings.currentIncomeDate;
        data.previousIncomeYearDate = settings.previousIncomeDate;

        return data;
    }

    public updateCurrencyAndDatesOfSelect(
        data: INotesSelectComponent,
        settings: IAnnualReportDefaultSettings,
    ): INotesSelectComponent {
        data.currentYearDate = settings.currentBalanceDate;
        data.previousYearDate = settings.previousBalanceDate;
        return data;
    }

    public updateDatesOfMovementsSchedule(
        data: IMovementScheduleComponent,
        settings: IAnnualReportDefaultSettings,
    ): IMovementScheduleComponent {
        return {
            ...data,
            currentBalanceYearDate: settings.currentBalanceDate,
            previousBalanceYearDate: settings.previousBalanceDate,
            currentIncomeYearDate: settings.currentIncomeDate,
            previousIncomeYearDate: settings.previousIncomeDate,
        };
    }
}
